"use client";
import { useAuth } from "@lib/auth/useAuth";
import { useIsLoyaltyMember } from "@hooks/useIsLoyaltyMember";
import { useGlobalModalContext } from "@components/GlobalModalProvider/GlobalModalProvider";
import { ModalTypes } from "@lib/enums/ModalTypes";
import {
    getPagePathByLocale,
    myAccountProfilePage,
    myAccountEccoClubPage,
} from "@lib/constants/pagePaths";
import { useLocale } from "next-intl";
import { NextLink } from "@components/ui/next-link/NextLink";
import { CTABar } from "./components/CTABar";
import { useEccoClubMicrocopies } from "./hooks/useEccoClubMicrocopies";
import { RUM_ACTION_NAME } from "@lib/monitoring/rumActionNames";

export const EccoClubCTAs = () => {
    const { isLoggedIn, isLoading: isAuthLoading } = useAuth();
    const { isLoyaltyMember, isLoading: isLoyaltyLoading } = useIsLoyaltyMember();
    const { showModal } = useGlobalModalContext();
    const locale = useLocale();
    const { createAccount, logIn, joinTheClub, seeBenefits, myAccount } = useEccoClubMicrocopies();

    const isLoading = isAuthLoading || isLoyaltyLoading;

    if (isLoading) {
        return <CTABar buttons={[{}, {}]} isLoading />;
    }

    if (!isLoggedIn) {
        return (
            <CTABar
                buttons={[
                    {
                        label: createAccount,
                        onClick: () => showModal(ModalTypes.createAccount),
                        "data-dd-action-name": RUM_ACTION_NAME.CREATE_ACCOUNT,
                    },
                    {
                        label: logIn,
                        onClick: () => showModal(ModalTypes.login),
                        "data-dd-action-name": RUM_ACTION_NAME.LOG_IN,
                    },
                ]}
            />
        );
    }

    const benefitsLink = getPagePathByLocale(myAccountEccoClubPage, locale);

    if (!isLoyaltyMember) {
        return (
            <CTABar
                buttons={[
                    { label: joinTheClub, onClick: () => showModal(ModalTypes.upgradeAccount) },
                    { label: seeBenefits, as: NextLink, href: benefitsLink },
                ]}
            />
        );
    }

    return (
        <CTABar
            buttons={[
                {
                    label: myAccount,
                    as: NextLink,
                    href: getPagePathByLocale(myAccountProfilePage, locale),
                },
                { label: seeBenefits, as: NextLink, href: benefitsLink },
            ]}
        />
    );
};
